import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core'

import { RouterModule } from '@angular/router'
import { LinkComponent } from '../link'
import { TypographyComponent } from '../typography'

@Component({
  selector: 'hyperkit-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  standalone: true,
  imports: [RouterModule, LinkComponent, TypographyComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent {
  @Input() text = ''
  @Input() selected = false
  @Input() inactive = false
  @Input() link?: string = ''
  @Input() clickable = false

  @Output() clicked = new EventEmitter<void>()

  onClick(): void {
    if (this.clickable) {
      this.clicked.emit()
    }
  }

  onKeydown(event: KeyboardEvent): void {
    if (this.clickable && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault()
      this.clicked.emit()
    }
  }
}
